const stateManager = require('./stateManager');

module.exports.dispatch = (action)=> 
{
    const store = stateManager.getStore();
    store.dispatch(action);
}